/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プレスリリース 配信先メディアリスト
 * @export
 * @interface PressReleaseMediaList
 */
export interface PressReleaseMediaList {
    /**
     * メディアリストid
     * @type {number}
     * @memberof PressReleaseMediaList
     */
    id: number;
    /**
     * メディアリスト名
     * @type {string}
     * @memberof PressReleaseMediaList
     */
    name: string;
    /**
     * メディアリストのメール配信者名
     * @type {string}
     * @memberof PressReleaseMediaList
     */
    senderName: string;
    /**
     * メディアリストのメール配信元アドレス
     * @type {string}
     * @memberof PressReleaseMediaList
     */
    senderAddress: string;
    /**
     * 送信先メディア数
     * @type {number}
     * @memberof PressReleaseMediaList
     */
    mediaCount: number;
    /**
     * リストの中にFaxが登録されている企業がある
     * @type {boolean}
     * @memberof PressReleaseMediaList
     */
    isExistsMail: boolean;
    /**
     * リストの中にFaxが登録されている企業がある
     * @type {boolean}
     * @memberof PressReleaseMediaList
     */
    isExistsFax: boolean;
}

export function PressReleaseMediaListFromJSON(json: any): PressReleaseMediaList {
    return PressReleaseMediaListFromJSONTyped(json, false);
}

export function PressReleaseMediaListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PressReleaseMediaList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'senderName': json['sender_name'],
        'senderAddress': json['sender_address'],
        'mediaCount': json['media_count'],
        'isExistsMail': json['is_exists_mail'],
        'isExistsFax': json['is_exists_fax'],
    };
}

export function PressReleaseMediaListToJSON(value?: PressReleaseMediaList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'sender_name': value.senderName,
        'sender_address': value.senderAddress,
        'media_count': value.mediaCount,
        'is_exists_mail': value.isExistsMail,
        'is_exists_fax': value.isExistsFax,
    };
}

